import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {BASE_TEXT} from '../../../style/typography';
import {CHARCOAL, TARMAC} from '../../../style/colors';
import {PHONE} from '../../../style/breakpoints';
import glamorous from 'glamorous';

const Container = glamorous.div({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  ' > div:first-of-type': {
    marginLeft: 0
  },
  [PHONE]: {
    width: '89%'
  }
});

const Item = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
});

const List = glamorous.ul({
  margin: 0,
  padding: 0
});

const ListItem = glamorous.li({
  ...BASE_TEXT,
  color: CHARCOAL,
  fontSize: 15,
  display: 'flex',
  '&::before': {
    content: '\u2022',
    padding: '3px 10px 0 5px'
  }
});

const ItemLabel = glamorous.div({
  ...BASE_TEXT,
  color: TARMAC,
  fontSize: 13,
  lineHeight: '28px',
  marginRight: 5
});

const StatsCardNew = ({items}) => {
  return (
    <Container>
      {items.map(({stat, label}, index) => (
        <List key={index}>
          <ListItem>
            <Fragment key={index}>
              <Item key={index}>
                <ItemLabel>
                  {label} - <strong>{stat}</strong>
                </ItemLabel>
              </Item>
            </Fragment>
          </ListItem>
        </List>
      ))}
    </Container>
  );
};

StatsCardNew.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      stat: PropTypes.any
    })
  )
};

export default StatsCardNew;
